var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.31 62.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fffdd3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283,456.32a3.52,3.52,0,0,1,.22-1.34,3.73,3.73,0,0,1,3.41-2.42,3.76,3.76,0,0,1,2.56.79,3.69,3.69,0,0,1,1.4,2.34,3.79,3.79,0,0,1-.72,3.05,4.09,4.09,0,0,1-1.18,1,3.76,3.76,0,0,1-5.69-3.43Zm6,.06a5.59,5.59,0,0,0-.08-.59A2.05,2.05,0,0,0,287,454.2a2.08,2.08,0,0,0-2.12,1.26,2.36,2.36,0,0,0-.18,1.14,2.15,2.15,0,0,0,4.3-.22Z",
    transform: "translate(-252.86 -406.43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.53,452.69l2.51,7.39h-1.65c-.23,0-.22,0-.29-.24s-.2-.6-.31-.91h-2.71l-.36,1.14h-1.85c.12-.42.23-.81.36-1.2.21-.62.44-1.23.66-1.84.37-1.08.72-2.17,1.09-3.25.09-.27.17-.54.26-.81s.1-.28.37-.28Zm-1.92,4.63h1.71l-.86-2.68Z",
    transform: "translate(-252.86 -406.43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.36,458.44h2.78v1.62h-5.06c0-.45,0-.88,0-1.31a.52.52,0,0,1,.1-.23c.32-.49.65-1,1-1.46s.67-1.07,1-1.6l.72-1.13h-2.72v-1.61h5c0,.25,0,.51,0,.76a1.44,1.44,0,0,1-.26.93c-.8,1.22-1.56,2.47-2.34,3.7l-.13.23C298.33,458.39,298.33,458.44,298.36,458.44Z",
    transform: "translate(-252.86 -406.43)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.8,454.32h-1.9v-1.61h5.45v1.6h-1.88v5.75H278.8Z",
    transform: "translate(-252.86 -406.43)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.48,467a1.87,1.87,0,0,1,.31-1.16,2.52,2.52,0,0,1,.27-.3,1.79,1.79,0,0,1,1.62-.62,2.08,2.08,0,0,1,1.86,1.66,2.2,2.2,0,0,1-.13,1.32,2.12,2.12,0,0,1-1.11,1.15,2.17,2.17,0,0,1-1.2.14,1.92,1.92,0,0,1-1.26-.83A2,2,0,0,1,258.48,467Zm1,.08a1.42,1.42,0,0,0,0,.19,1,1,0,0,0,.79.87,1,1,0,0,0,1.13-.48,1.16,1.16,0,0,0,0-1.22,1,1,0,0,0-1.15-.47A1.07,1.07,0,0,0,259.49,467.12Z",
    transform: "translate(-252.86 -406.43)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.1,469.24a1.44,1.44,0,0,1-1-.32,2.19,2.19,0,0,1-.84-1.12,2.88,2.88,0,0,1-.06-.59,2.16,2.16,0,0,1,.54-1.64,2.1,2.1,0,0,1,3.08.13,2.28,2.28,0,0,1,.1,2.64A2,2,0,0,1,306.1,469.24Zm1.2-2.15a1.89,1.89,0,0,0-.08-.4,1,1,0,0,0-1.14-.7,1.1,1.1,0,1,0,1.22,1.1Z",
    transform: "translate(-252.86 -406.43)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.25,468.77l-.3.24a1.61,1.61,0,0,1-.94.23,1.13,1.13,0,0,1-.94-.43,1.22,1.22,0,0,1-.37-.81c0-1,0-1.92-.05-2.91h1a1.5,1.5,0,0,1,0,.22v2.11a.86.86,0,0,0,.16.58.81.81,0,0,0,1.29-.15,1.27,1.27,0,0,0,.17-.69v-2.07h1v4h-1l0-.32v0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.63,465.39a.72.72,0,0,1,.44-.32,1.54,1.54,0,0,1,1.56.2,1.43,1.43,0,0,1,.53,1.11c0,.9,0,1.8,0,2.72h-1c0-.08,0-.15,0-.23,0-.59,0-1.19,0-1.78a4.2,4.2,0,0,0-.06-.61.63.63,0,0,0-.66-.51c-.11,0-.22,0-.32,0a.69.69,0,0,0-.51.54,1.7,1.7,0,0,0-.05.44v2.15h-1v-4h1l0,.28v.07Z",
    transform: "translate(-252.86 -406.43)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.46,469.11h-1a1.85,1.85,0,0,1,0-.23c0-.7,0-1.39,0-2.09A.81.81,0,0,0,267,466a.79.79,0,0,0-1.13.59,3.39,3.39,0,0,0,0,.45v1.75c0,.1,0,.19,0,.3h-1v-4h1l0,.32a1.34,1.34,0,0,1,1.21-.45,1.37,1.37,0,0,1,1.34,1.24,8.94,8.94,0,0,1,.06,1V469A.81.81,0,0,1,268.46,469.11Z",
    transform: "translate(-252.86 -406.43)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.55,468.26,271,468l.43-.26.11.16a.82.82,0,0,0,.85.36.36.36,0,0,0,.34-.3c0-.14-.07-.26-.27-.32l-1-.31a1.05,1.05,0,0,1-.72-1,1.6,1.6,0,0,1,0-.49A1.24,1.24,0,0,1,272,465a1.79,1.79,0,0,1,1.27.29,1.13,1.13,0,0,1,.44.57l-.82.46a.88.88,0,0,0-.51-.36.75.75,0,0,0-.39,0,.26.26,0,0,0,0,.46,2.39,2.39,0,0,0,.43.2c.21.07.43.11.64.19a1.11,1.11,0,0,1,.79,1,1.15,1.15,0,0,1-.61,1.21,1.66,1.66,0,0,1-.84.23,2,2,0,0,1-.91-.1A1.7,1.7,0,0,1,270.55,468.26Z",
    transform: "translate(-252.86 -406.43)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.65,468.18a1.9,1.9,0,0,1-.76.78,2.06,2.06,0,0,1-1.11.28,1.88,1.88,0,0,1-1.57-.87,2.26,2.26,0,0,1-.34-1.58,1.89,1.89,0,0,1,.57-1.27,2,2,0,0,1,1.85-.53,1.86,1.86,0,0,1,1.35,1l-.88.53a1.19,1.19,0,0,0-.56-.46,1,1,0,0,0-1.2.43,1.18,1.18,0,0,0,.18,1.4,1,1,0,0,0,1.35,0l.09-.08c.2-.2.2-.19.43-.05Z",
    transform: "translate(-252.86 -406.43)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.36,468.18a2,2,0,0,1-1.7,1.06,1.67,1.67,0,0,1-1.17-.3,2.17,2.17,0,0,1-.88-1.16,4.16,4.16,0,0,1,0-1,1.82,1.82,0,0,1,.83-1.48,2.06,2.06,0,0,1,1.48-.33,1.89,1.89,0,0,1,1.43,1s0,0,0,.07l-.87.53a1,1,0,0,0-.66-.52.9.9,0,0,0-.92.25,1.19,1.19,0,0,0,0,1.62,1,1,0,0,0,1.46,0c.17-.2.15-.19.37-.07S294.12,468,294.36,468.18Z",
    transform: "translate(-252.86 -406.43)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.8,466.15c0,.53,0,1.05,0,1.58,0,.33.1.42.43.44h.45v.93a3.06,3.06,0,0,1-1.28,0,.48.48,0,0,1-.23-.13,1.08,1.08,0,0,1-.37-.81c0-.66,0-1.31,0-2l0,0h-.58v-1h.64c0-.24,0-.45,0-.65s0-.22.2-.25.52-.16.81-.25v1.13h.87v1l-.81,0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.22,465.07h.86v1h-.83a1.65,1.65,0,0,0,0,.21c0,.49,0,1,0,1.48,0,.27.11.37.38.4h.46v.94a1.18,1.18,0,0,1-.21,0c-.29,0-.59,0-.89,0a1,1,0,0,1-.72-.87c0-.61,0-1.23,0-1.84v-.32h-.67v-1h.66v-.83l1-.32Z",
    transform: "translate(-252.86 -406.43)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.49,465.57c.21-.47.63-.54,1.1-.59v1.12a6.55,6.55,0,0,0-.67.18.68.68,0,0,0-.46.59c0,.15,0,.3,0,.44v1.8h-1v-4h1v.63Z",
    transform: "translate(-252.86 -406.43)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.15,465.08h1v4h-1C301.11,468.91,301.09,465.52,301.15,465.08Z",
    transform: "translate(-252.86 -406.43)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.3,464l-.17.31a.63.63,0,0,1-1,0,.73.73,0,0,1,.07-.89.63.63,0,0,1,.71-.1.55.55,0,0,1,.32.36C302.23,463.81,302.26,463.9,302.3,464Z",
    transform: "translate(-252.86 -406.43)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M265.1,435.48v0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.49,465.57l-.06.15v-.17Z",
    transform: "translate(-252.86 -406.43)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.63,465.39l-.05.05v-.07Z",
    transform: "translate(-252.86 -406.43)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.8,466.15l.05,0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.72,466.1l0,0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.25,468.77l0,0v0h0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.23,413.67H276.29l6.51-6.84a1.26,1.26,0,0,1,1.84,0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.31,422.06h-31c1.89-2,3.8-4,5.71-6h19.5l5.78,6Z",
    transform: "translate(-252.86 -406.43)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.13,444.22c0-3.31,0-6.22.06-9.13,0-.35.68-.86,1.12-1q11.94-3.19,23.89-6.31c2.31-.61,7.08-1.78,8.69-2.15a.66.66,0,0,1,.75.41h0Z",
    transform: "translate(-252.86 -406.43)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.27,440.87H289.36l12.79-13.43C302.16,427.51,302.24,435.56,302.27,440.87Z",
    transform: "translate(-252.86 -406.43)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.26,
    y: 39.74,
    width: 37.1,
    height: 2.68
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.f173e678e2905baeffb79951f4e3598d.svg";
export { ForwardRef as ReactComponent };